import React from 'react';

import { BrowserRouter as Router } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom';

import LoginPage from './components/LoginPage';
import ScrappingScneario from './components/ScrappingScenario' 
import CheckingCapter from './components/CheckingChapter';
import AdminPage from './components/AdminPage';

const App: React.FC = () => {
  
  return (
    <Router>

      <Routes>
        <Route path="/" element={<LoginPage />}/>
        <Route path="/Scrapping" element={<ScrappingScneario />}/>
        <Route path="/Checking" element={<CheckingCapter />}/>
        <Route path="/Admin" element={<AdminPage />}/>
      </Routes>

    </Router>
  );
};

export default App;
